var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero-wrapper"},[_c('Hero'),_c('Collection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }